import { createFileRoute } from "@tanstack/react-router";
import AdminKnowledgePage from "@/admin/pages/knowledge";

export const Route = createFileRoute("/admin/knowledge/")({
  component: AdminKnowledgePage,
});
